import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-radar-line text-3xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">这条线索跑到别处了</h1>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
        你访问的页面不存在，可能是链接已经失效。回到首页看看此刻正在冲榜的话题吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/ranking"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看全网热搜榜
        </Link>
      </div>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
        {categories.slice(0, 6).map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
}